'use strict';
import * as $j_java$002eio$002e$002dOutput$002dStream from "./java.io.-Output-Stream.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $ct_Ljava_io_FilterOutputStream__Ljava_io_OutputStream__($thiz, out) {
  return $thiz;
}
export { $ct_Ljava_io_FilterOutputStream__Ljava_io_OutputStream__ as $ct_Ljava_io_FilterOutputStream__Ljava_io_OutputStream__ };
/** @constructor */
function $c_Ljava_io_FilterOutputStream() {
}
export { $c_Ljava_io_FilterOutputStream as $c_Ljava_io_FilterOutputStream };
$p = $c_Ljava_io_FilterOutputStream.prototype = new $j_java$002eio$002e$002dOutput$002dStream.$h_Ljava_io_OutputStream();
$p.constructor = $c_Ljava_io_FilterOutputStream;
/** @constructor */
function $h_Ljava_io_FilterOutputStream() {
}
export { $h_Ljava_io_FilterOutputStream as $h_Ljava_io_FilterOutputStream };
$h_Ljava_io_FilterOutputStream.prototype = $p;
